<template>
  <div class="wholesaleIndex">  
    <mu-appbar class="XR-head" title="批发市场">
        <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
        <mu-icon-button to="/wholesale/search" icon=":fa fa-mysearch3" slot="right"/>
    </mu-appbar>  

    <div class="bannerDiv">
      <router-link :to="bannerAd.AdLink"><img :src="bannerAd.AdImg" class="banner"></router-link>
    </div>

    <div class="pro-list">
      <div :class="'item'+ (index%2==0?' rigthmargin':'') " v-for="(productItem,index) in integralProductList" :key="productItem.ProductId">
        <div class="top">
          <router-link :to="'/wholesale/ProductDetail?skuId='+ productItem.SkuId"><img :style="{height: imgHeight+'px'}" :src="productItem.DefaultImage?productItem.DefaultImage: IMGServer_URL+'/images/index-item-default.png'" class="pro-img"></router-link>
        </div>
        <div class="text">
          <div class="money">
            <p class="price">￥<span>{{productItem.SalePrice.toFixed(2)}}</span></p>
            <p class="del-price">￥{{productItem.Price.toFixed(2)}}</p>
          </div>
          <router-link :to="'/wholesale/ProductDetail?skuId='+ productItem.SkuId"><p class="name">{{productItem.ProductName}}</p></router-link>
          <p class="buycount">{{productItem.SaleCount}}人已购买</p>
        </div>
    </div>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
    <XR-signin ref="XRsigin" @onClose="readSignInfo"></XR-signin>
	<XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>

<script>
export default {
  data(){
    return {
      integralProductList:[],
      bannerAd:{},
      AdLeft:{},
      AdRight:{},
      NowSignInfo:{},
      TomorrowSignInfo:{},
      memberFinance:{},
      sWidth : document.documentElement.clientWidth,
      isLogin:false,
      imgHeight: 0
    }
  },
  mounted(){
    this.getPurchaseProductList()
    this.getIntegralAdList()

    if (this.$store.state.user.SessionId) {
      this.isLogin =true
    }
    this.imgHeight = this.sWidth*0.49  
  },
  methods:{    
    GoHistory(){
      this.$router.goBack()
    },
    getIntegralAdList(){
      const ths = this;
      this.$post("/Shop/AdServer/GetAdsByPage",{ClientType:2, pageId:'c741b55d87384efdb268a78900f91171'})
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false
          
          for(var i = 0; i< res.Data.length;i++){
            if(res.Data[i].AdName == '积分商城banner广告'){
              ths.bannerAd = res.Data[i];
            }
            else if(res.Data[i].AdName == '积分商城横幅广告（左）'){
              ths.AdLeft = res.Data[i];
            }
            else if(res.Data[i].AdName == '积分商城横幅广告（右）'){
              ths.AdRight = res.Data[i];
            }
          }

          ths.$refs.XRtoast.hide()
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    getPurchaseProductList(){
      const ths = this;
      this.$post("/Shop/PurchaseServer/GetPurchaseProductList")
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false
          ths.integralProductList = res.Data.List
          ths.$refs.XRtoast.hide()
        } else {
		  res.Msg = "暂无上架商品"
          ths.$refs.XRPageTip.ShowEmpty(res.Msg)
		}
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    toBeOnline:function(){
      this.$refs.XRtoast.load('拼命开发中...',true);
    }
  }
}
</script>

<style>
.XR-head .mu-appbar{
  height: 46px;
  text-align: center;
}
.XR-head .mu-appbar.fixed{  
  padding:0;
  position: fixed;
  top:0;
  left: 0;
}
.XR-head .mu-appbar-title {
  font-size: 16px;
}
.XR-head .title .mu-icon-button {
  position: absolute;
  left: 0;
  top: 0;
  color:white;
}
.XR-head .title .title-text {
  margin: 0;
  line-height: 48px;
}
.wholesaleIndex .banner
{
    width:100%;    
    display:block;
}
.wholesaleIndex .ph-nav{
  padding:.8rem 0;
  background:white;
  overflow: hidden;
}
.wholesaleIndex .pro-list { background:#EEEDEE;margin-top: 0.8rem;}
 .pro-list .item { width:49%; float:left; margin-bottom:5px; background:white;}
.wholesaleIndex .pro-list .item.rigthmargin { margin-right:2%;}
.wholesaleIndex .pro-list .item .top { position:relative;}
.wholesaleIndex .pro-list .item .top img { width:100%; display:block;}
.wholesaleIndex .pro-list .item .top .dk { position:absolute; top:4px; right:4px; color:red;   text-align:center;}
.wholesaleIndex .pro-list .item .top .dk span { font-size:12px; display:block; height:14px; line-height:14px; font-weight:700;}
.wholesaleIndex .pro-list .text { padding:0 5px;}
.wholesaleIndex .pro-list .text .money { font-size:12px; overflow:hidden; margin:5px 0;} 
.wholesaleIndex .pro-list .text .money .price { float:left;color:Red;  padding-left:5px; line-height:1.0rem;}
.wholesaleIndex .pro-list .text .money .price span { font-size:16px; font-weight:700;}
.wholesaleIndex .pro-list .text .money .del-price { float:left; color:#A0A0A0; text-decoration:line-through; margin-left:10px; line-height:18px;}
.wholesaleIndex .pro-list .item .name {   width:100%; overflow:hidden; height:36px; line-height:18px; font-size:12px;}
.wholesaleIndex .pro-list .item .buycount { margin-bottom:5px; width:100%; overflow:hidden; height:16px; text-align:right; color:#EF8367; line-height:16px; font-size:12px;}

      
.wholesaleIndex .signin { height:70px; background:#F9CC9D; overflow:hidden;}
.wholesaleIndex .signin .left { float:left;margin-left:5px;}
.wholesaleIndex .signin .left .box-open { float:left; margin-top:6px; width:55px;}
.wholesaleIndex .signin .left .info { float:left; margin-top:21px; margin-left:4px;}
.wholesaleIndex .signin .left .info .desc { font-size:12px; overflow:hidden; }
.wholesaleIndex .signin .left .info .desc .special { font-size:16px;line-height:16px; color:#FF0000; float:left;}
.wholesaleIndex .signin .left .info .desc .normal { font-size:12px; line-height:14px; margin-left:5px; float:left;}
.wholesaleIndex .signin .left .info .tip { font-size:12px; line-height:12px; margin-top:3px;}
.wholesaleIndex .signin .right { float:right; margin-right:5px;}
.wholesaleIndex .signin .right .signin-btn { float:left; margin-top:14px; width:46px;}
.wholesaleIndex .signin .right .btn { float:left; margin-top:22px;margin-left:2px;}
.wholesaleIndex .signin .right .btn .btn-text { font-size:12px;line-height:12px;}
.wholesaleIndex .signin .right .btn .award { font-size:12px;line-height:12px; margin-top:6px;}  
</style>




// WEBPACK FOOTER //
// src/pages/wholesale/index.vue